import { PaymentTypes } from '~/constants/financeConstants'
import type { InvoiceOrEstimate } from '~/types'

export interface PaymentDialogParams {
  includeServiceFee: boolean
  invoice: InvoiceOrEstimate
  isPosTerminalMigrationEnabled: boolean
  paymentController: {
    addPayment: (params: any) => void
  }
  setIsBraintreePaymentOpen: (value: boolean) => void
}

export const createPaymentDialogParams = ({
  invoice,
  includeServiceFee,
  isPosTerminalMigrationEnabled,
  setIsBraintreePaymentOpen,
}: Omit<PaymentDialogParams, 'paymentController'>) => {
  if (!invoice) return undefined

  const { id, dueToPayNoFee, clientId } = invoice

  return {
    addPaymentDialogProps: {
      clientId,
      ComponentProps: {
        invoiceAmount: dueToPayNoFee,
        assignedInvoiceId: id,
        invoiceIds: [id],
        paymentType: includeServiceFee
          ? PaymentTypes.CREDIT_CARD
          : PaymentTypes.OTHER,
      },
    },
    posTerminalMigrationAction: isPosTerminalMigrationEnabled
      ? () => {
          setIsBraintreePaymentOpen(true)
        }
      : undefined,
  }
}

export const openPaymentDialogAfterSaving = ({
  invoice,
  includeServiceFee,
  isPosTerminalMigrationEnabled,
  paymentController,
  setIsBraintreePaymentOpen,
}: PaymentDialogParams) => {
  const params = createPaymentDialogParams({
    invoice,
    includeServiceFee,
    isPosTerminalMigrationEnabled,
    setIsBraintreePaymentOpen,
  })

  if (params) {
    paymentController.addPayment(params)
  }
}
